var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealEstateAgent24DpFill0Wght400Grad0Opsz241(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 35V18.75L35 10L22.5 18.75V22.5H17.5V16.25L35 3.75L52.5 16.25V35H47.5ZM36.25 20H38.75V17.5H36.25V20ZM31.25 20H33.75V17.5H31.25V20ZM36.25 25H38.75V22.5H36.25V25ZM31.25 25H33.75V22.5H31.25V25ZM17.5 46.25L34.875 51L49.75 46.375C49.5417 46 49.2396 45.6771 48.8438 45.4062C48.4479 45.1354 48 45 47.5 45H34.875C33.75 45 32.8542 44.9583 32.1875 44.875C31.5208 44.7917 30.8333 44.625 30.125 44.375L24.3125 42.4375L25.6875 37.5625L30.75 39.25C31.4583 39.4583 32.2917 39.625 33.25 39.75C34.2083 39.875 35.625 39.9583 37.5 40C37.5 39.5417 37.3646 39.1042 37.0938 38.6875C36.8229 38.2708 36.5 38 36.125 37.875L21.5 32.5H17.5V46.25ZM2.5 55V27.5H21.5C21.7917 27.5 22.0833 27.5312 22.375 27.5938C22.6667 27.6562 22.9375 27.7292 23.1875 27.8125L37.875 33.25C39.25 33.75 40.3646 34.625 41.2188 35.875C42.0729 37.125 42.5 38.5 42.5 40H47.5C49.5833 40 51.3542 40.6875 52.8125 42.0625C54.2708 43.4375 55 45.25 55 47.5V50L35 56.25L17.5 51.375V55H2.5ZM7.5 50H12.5V32.5H7.5V50Z",
    fill: "#031273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstateAgent24DpFill0Wght400Grad0Opsz241);
export default __webpack_public_path__ + "static/media/real_estate_agent_24dp_FILL0_wght400_GRAD0_opsz24 1.7dcd1947b993a406ece63b92edaf67b6.svg";
export { ForwardRef as ReactComponent };